import mlFunctionsClient from '../interceptor.mlFunctionsClient';

const movementAnalyticsEndpoints = {
  getSummary: (config) =>
    mlFunctionsClient.get('/GetMovementSummary', config),

  checkVelocity: (config) =>
    mlFunctionsClient.get('/CheckVelocityThreshold', config),
};

export default movementAnalyticsEndpoints;
